module.exports = __webpack_public_path__ + "static/img/s505.0bdf946.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s505.png
// module id = 567
// module chunks = 3